// AllReferrals.ts
import { referralService } from "../../../services/referralService";
import { ReferralsSkeleton } from "./ReferralsSkeleton";
import { formatToLocalDate } from "../../../utils/formatToLocalDate";
import { TotalEarning } from "./TotalEarning";

interface Referral {
  mask_name: string;
  mask_email: string;
  user_type: string;
  user_credits: number;
  created_at: string; // or Date if needed
}

export function AllReferrals() {
  let totalEarningComponent = TotalEarning();
  let $skeletonSection: null | HTMLElement = null;
  let $referralListElement: null | HTMLElement = null;
  const children = {
    referralsSkeleton: ReferralsSkeleton(),
  }
  async function populate() {
    $skeletonSection!.classList.remove("hidden");
    $referralListElement!.classList.add("hidden");
    const response = await referralService.list();
    response.total_user_credit ? totalEarningComponent.updateTotalEarning(response.total_user_credit) : '';
    renderReferralList(response.data.data ?? []);
  }

  function init() {
    $skeletonSection = document.getElementById("skeleton-section");
    $referralListElement = document.getElementById("referral-list");
  }

  function renderReferralList(referrals: Referral[]) {
    let rowsHTML;
    $referralListElement!.innerHTML = ""
    if (referrals.length == 0) {
      rowsHTML = renderEmptyRow();
    } else {
      rowsHTML = referrals.map(renderReferralRow).join('');
    }

    // Insert all rows at once into the table body
    $referralListElement!.innerHTML = rowsHTML;
    $referralListElement!.classList.remove("hidden");
    $skeletonSection!.classList.add("hidden");
  };

  function renderReferralRow(referral: Referral) {
    return `
        <tr>
            <td class="size-px whitespace-nowrap pe-4 py-3">
              <div class="grow">
                <span class="text-sm text-stone-600 dark:text-neutral-400">
                  ${referral.mask_name}
                </span>
              </div>
            </td>
            <td class="size-px whitespace-nowrap px-4 py-3">
              <span class="text-sm text-stone-600 dark:text-neutral-400">
                ${referral.mask_email}
              </span>
            </td>
            <td class="size-px whitespace-nowrap px-4 py-3">
              <span class="text-sm text-stone-600 dark:text-neutral-400">
                ${referral.user_type}
              </span>
            </td>
            <td class="size-px whitespace-nowrap px-4 py-3">
              <span class="text-sm text-stone-600 dark:text-neutral-400">
                ${referral.user_credits}
              </span>
            </td>
            <td class="size-px whitespace-nowrap px-4 py-3">
              <span class="text-sm text-stone-600 dark:text-neutral-400">
                ${formatToLocalDate(referral.created_at)}
              </span>
            </td>
        </tr>
    `;
  };

  function renderEmptyRow() {
    return `
        <tr>
            <td class="size-px whitespace-nowrap pe-4 py-3 text-center" colspan="5">
                <span class="text-sm text-stone-600 dark:text-neutral-400">
                  No signups. Please share your referral links with friends.
                </span>
            </td>
        </tr>
    `;
  };

  function render() {
    return /*html*/ `
      <div class="p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700" id="referral-container">
        <div class="space-y-8">
          <div class="overflow-x-auto">
            <div>
              <h3 class="text-lg font-semibold text-gray-800 dark:text-neutral-200 mr-1">All Referrals</h3>
              <p class="text-sm text-gray-500 dark:text-neutral-500">History of signups via your referral links</p>
            </div>
            <div class="min-w-full inline-block pt-6 align-middle bg-white dark:bg-neutral-800">
              <table class="min-w-full divide-y divide-gray-200 dark:divide-neutral-700">
                <thead>
                  <tr>
                    <th scope="col">
                      <div class="pe-4 py-3 text-start text-sm font-medium text-stone-800 dark:text-neutral-200">Name</div>
                    </th>
                    <th scope="col" class="min-w-36">
                      <div class="px-4 py-3 text-start text-sm font-medium text-stone-800 dark:text-neutral-200">Email</div>
                    </th>
                    <th scope="col">
                      <div class="px-4 py-3 text-start text-sm font-medium text-stone-800 dark:text-neutral-200">Type</div>
                    </th>
                    <th scope="col">
                      <div class="px-4 py-3 text-start text-sm font-medium text-stone-800 dark:text-neutral-200">Credits</div>
                    </th>
                    <th scope="col">
                      <div class="px-4 py-3 text-start text-sm font-medium text-stone-800 dark:text-neutral-200">Date</div>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-neutral-700 hidden" id="skeleton-section">
                 ${children.referralsSkeleton.render()}
                </tbody>
                <tbody class="divide-y divide-gray-200 dark:divide-neutral-700" id="referral-list">
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>`;
  }

  return { render, init, populate };
}
